import { render, staticRenderFns } from "./PageTitleHeader.vue?vue&type=template&id=a5bdfc14&"
import script from "./PageTitleHeader.vue?vue&type=script&lang=ts&"
export * from "./PageTitleHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports